import Operation from "../index.js";

export default {
    matchs(id, fn) {
        Operation.Http.post(`/match/matchs?institutionId=${id}`, null, fn);
    },
    //赛事列表
    matchList(params, fn) {
        Operation.Http.post(`/match/matchList`, params, fn);
    },
    //赛事详情
    matchDetail(id, fn) {
        Operation.Http.post(`/match/matchDetail?matchId=${id}`, null, fn)
    },
    //赛项列表
    matchItemSelectList(id, fn) {
        Operation.Http.post(`/match/matchItemSelectList?matchId=${id}`, null, fn)
    },
    //组别列表
    matchItemGroupSelectList(id, fn) {
        Operation.Http.post(`/match/matchItemGroupSelectList?matchItemId=${id}`, null, fn)
    },
    // 赛事 列表
    matchSelectList(fn){
      Operation.Http.post(`/match/matchSelectList`, null, fn)
    },
    // 查找赛事
    findMatch(id, fn) {
        Operation.Http.post(`/match/findMatch?matchId=${id}`, null, fn)
    },

}



// WEBPACK FOOTER //
// ./src/request/api/match.js